import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	issuePriorityTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	issuePriorityTitle: {
		id: 'servicedesk-insight-object-issue-card.priority.issue-priority-title',
		defaultMessage: 'Priority: {issuePriorityName}',
		description: 'A text title for the issue priority icon, mainly for accessibility purposes.',
	},
});
export default messages;
